import Cookies from "js-cookie";
import http from "@/http";
import jwtDecode from "jwt-decode";

export default {
  loggedIn() {
    return !!Cookies.get("log-token");
  },
  login(email, password) {
    return http.post("login", { email, password }).then((data) => {
      Cookies.set("log-token", data);
      let userData = this.getUserData(data);
      try {
        let homes = userData.homes.map((home) => home.name);
        window.dataLayer.push({
          event: "login",
          userID: userData.userID,
          homes: homes.join(","),
        });
      } catch (e) {
        console.log(e);
      }
      return userData.homes;
    });
  },
  logout() {
    Cookies.remove("log-token");
  },
  getHomes() {
    let userData = this.getUserData();
    return userData.homes;
  },
  isUserAllowedInHome(homeSlug) {
    let homes = this.getHomes();
    return homes.find((home) => home.slug == homeSlug);
  },
  getUserData(data = null) {
    if (!data) {
      data = this.getToken();
    }
    return jwtDecode(data);
  },
  getToken() {
    return Cookies.get("log-token");
  },
};
